import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appHighlightColumn]'
})
export class HighlightColumnDirective {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter', ['$event.target']) onMouseEnter(cell: HTMLElement) {
    const cellIndex = (cell as HTMLTableCellElement).cellIndex;
    if (cellIndex === undefined) return;

    const rowElements = this.el.nativeElement.closest('table').rows;
    for (let i = 0; i < rowElements.length; i++) {
      const targetCell = rowElements[i].cells[cellIndex];
      if (targetCell) {
        this.renderer.addClass(targetCell, 'hover-column');
      }
    }
  }

  @HostListener('mouseleave', ['$event.target']) onMouseLeave(cell: HTMLElement) {
    const cellIndex = (cell as HTMLTableCellElement).cellIndex;
    if (cellIndex === undefined) return;

    const rowElements = this.el.nativeElement.closest('table').rows;
    for (let i = 0; i < rowElements.length; i++) {
      const targetCell = rowElements[i].cells[cellIndex];
      if (targetCell) {
        this.renderer.removeClass(targetCell, 'hover-column');
      }
    }
  }
}
